import './TermsOfUseView.css'

import { useNavigate } from 'react-router'

export function TermsOfUseView() {
  const navigate = useNavigate()
  return (
    <div className="terms-of-use-view">
      <h1 className="terms-of-use-view__title">Terms of Use</h1>
      <p className="terms-of-use-view__effective">Effective Date: January 25, 2025</p>

      <section className="terms-of-use-view__section">
        <h2 className="terms-of-use-view__heading">1. Acceptance of Terms</h2>
        <p className="terms-of-use-view__text">
          By accessing or using Revel Club, you agree to be bound by these Terms of Use. If you do
          not agree to these terms, you may not use our services.
        </p>
      </section>

      <section className="terms-of-use-view__section">
        <h2 className="terms-of-use-view__heading">2. Eligibility</h2>
        <p className="terms-of-use-view__text">
          You must be at least 18 years old to use Revel Club. By using our services, you represent
          and warrant that you meet this requirement.
        </p>
      </section>

      <section className="terms-of-use-view__section">
        <h2 className="terms-of-use-view__heading">3. Membership</h2>
        <p className="terms-of-use-view__text">
          Revel Club is an exclusive, members-only community. Membership is granted at our sole
          discretion and may be revoked at any time for any reason, including but not limited to
          violation of these terms or conduct deemed inappropriate by our team.
        </p>
      </section>

      <section className="terms-of-use-view__section">
        <h2 className="terms-of-use-view__heading">4. Member Conduct</h2>
        <p className="terms-of-use-view__text">As a member, you agree to:</p>
        <ul className="terms-of-use-view__list">
          <li>Provide accurate and truthful information in your profile</li>
          <li>Treat other members with respect and dignity</li>
          <li>Engage genuinely and in good faith with matches</li>
          <li>Not harass, abuse, or harm other members</li>
          <li>Not use the platform for commercial purposes or solicitation</li>
          <li>Not create multiple accounts or impersonate others</li>
        </ul>
      </section>

      <section className="terms-of-use-view__section">
        <h2 className="terms-of-use-view__heading">5. Content</h2>
        <p className="terms-of-use-view__text">
          You retain ownership of content you submit to Revel Club. By submitting content, you grant
          us a non-exclusive, worldwide, royalty-free license to use, display, and distribute your
          content in connection with operating the service.
        </p>
      </section>

      <section className="terms-of-use-view__section">
        <h2 className="terms-of-use-view__heading">6. Privacy</h2>
        <p className="terms-of-use-view__text">
          Your use of Revel Club is also governed by our Privacy Policy. Please review our Privacy
          Policy to understand how we collect, use, and protect your information.
        </p>
      </section>

      <section className="terms-of-use-view__section">
        <h2 className="terms-of-use-view__heading">7. Termination</h2>
        <p className="terms-of-use-view__text">
          We reserve the right to suspend or terminate your membership at any time, with or without
          cause, and with or without notice. You may also terminate your membership at any time by
          contacting us.
        </p>
      </section>

      <section className="terms-of-use-view__section">
        <h2 className="terms-of-use-view__heading">8. Disclaimer</h2>
        <p className="terms-of-use-view__text">
          Revel Club is provided "as is" without warranties of any kind. We do not guarantee that
          you will find a match or that the service will meet your expectations. We are not
          responsible for the actions or conduct of any member.
        </p>
      </section>

      <section className="terms-of-use-view__section">
        <h2 className="terms-of-use-view__heading">9. Changes to Terms</h2>
        <p className="terms-of-use-view__text">
          We may update these Terms of Use from time to time. Continued use of Revel Club after
          changes constitutes acceptance of the updated terms.
        </p>
      </section>

      <section className="terms-of-use-view__section">
        <h2 className="terms-of-use-view__heading">10. Contact</h2>
        <p className="terms-of-use-view__text">
          If you have questions about these Terms of Use, please contact us at{' '}
          <a href="mailto:support@revel.club" className="terms-of-use-view__link">
            support@revel.club
          </a>
          .
        </p>
      </section>

      <div className="terms-of-use-view__back">
        <button type="button" className="terms-of-use-view__back-link" onClick={() => navigate(-1)}>
          Back
        </button>
      </div>
    </div>
  )
}
